<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading">
      <a-page-header
        :ghost="false"
        sub-title="Новость"
        @back="() => $router.go(-1)"
      >
        <template slot="extra" />
        <a-row
          :class="{ 'form-group--error': emptyTitle }"
          align="middle"
          class="flex-baseline"
          style="margin: 0 0 30px 0"
        >
          <a-textarea
            v-model="form.title[langTab]"
            :auto-size="{ minRows: 1, maxRows: 10 }"
            size="small"
            placeholder="Введите заголовок"
            class="ant-page-header-heading-title"
            @input="hotGenerateSlug($event, form, langTab, 'post', 'news')"
          />
        </a-row>
        <div v-if="isTitleNull" class="error-text">
          Введите заголовок на одном из языков.
        </div>

        <!-- author full name -->
        <a-row v-if="form.id && form.author" class="sm-mb">
          <span class="author-full-name text-capitalize"
            >Текст: {{ form.author.first_name }}
            {{ form.author.last_name }}</span
          >
        </a-row>

        <a-descriptions size="small" :column="4">
          <a-descriptions-item label="ID">
            {{ form.id || "New" }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.created" label="Создан">
            {{ moment(form.created).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.updated" label="Обновлен">
            {{ moment(form.updated).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.views" label="Просмотры">
            {{ form.views }}
          </a-descriptions-item>
          <a-descriptions-item label="Опубликован">
            <a-switch v-model="form.status" />
          </a-descriptions-item>
          <a-descriptions-item :label="`Доступность на языке ${langTab}`">
            <a-switch v-model="form.language_support[langTab]" />
          </a-descriptions-item>

          <!-- <a-descriptions-item label="Эксклюзивная новость">
            <a-switch v-model="form.is_main" />
          </a-descriptions-item>

          <a-descriptions-item label="Рекомендованная новость">
            <a-switch v-model="form.recommended" />
          </a-descriptions-item>-->
        </a-descriptions>
      </a-page-header>

      <a-tabs :key="$route.fullPath" type="card" @change="tabPaneChangeHandler">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="4" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="18">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <a-row
            :class="{ 'form-group--error': emptyExcerp }"
            align="middle"
            class="flex-baseline"
          >
            <a-col :span="4" style="text-align: right; padding-right: 8px">
              Подзаголовок:
            </a-col>
            <a-col :span="18" class="sm-mb">
              <a-textarea
                v-model="form.excerp[langTab]"
                placeholder="Введите подзаголовок"
                :auto-size="{ minRows: 1, maxRows: 6 }"
              />
              <!--              <div v-if="isExcerpNull" class="error-text">Введите подзаголовок на одном из языков.</div>-->
            </a-col>
          </a-row>

          <!-- slug -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" style="text-align: right; padding-right: 8px">
              ЧПУ:
            </a-col>
            <a-col :span="18" class="sm-mb">
              <a-row align="middle" type="flex">
                <span class="mr-1 link" @click="copySlug">
                  <a-icon :style="{ fontSize: '22px' }" type="copy" />
                </span>

                <span class="flex-1">
                  <a-col :span="18">
                    <a-input
                      id="slug-input"
                      :value="form.slug"
                      placeholder="Введите человеку понятный урл"
                      @input="onSlugChange"
                    />
                  </a-col>
                  <a-col :span="4">
                    <a-tooltip
                      placement="topLeft"
                      :title="`Генерация ЧПУ на  ${langTab}`"
                    >
                      <a-button
                        :disabled="!form.title[langTab]"
                        class="ml-1"
                        block
                        type="primary"
                        @click="
                          $__slugCompute({
                            event: $event,
                            langTab: langTab,
                            type: 'post',
                            title: form.title,
                            postType: 'news'
                          })
                        "
                      >
                        {{ langTab }}
                        <a-icon type="reload" />
                      </a-button>
                    </a-tooltip>
                  </a-col>
                </span>
              </a-row>

              <!-- <a-row
                type="flex"
                style="margin-top: 15px"
                align="middle"
              >
                <span style="padding-right: 10px">Автотранслит ЧПУ</span>
                <a-switch v-model="form.status" />
              </a-row>-->

              <div v-if="!form.slug" class="error-text">Введите ЧПУ.</div>
              <div
                v-if="errors.slug && current_slug != form.slug"
                class="z-error-text"
              >
                Данный ЧПУ недоступен
              </div>
            </a-col>
          </a-row>

          <!-- Теги -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" style="text-align: right; padding-right: 8px">
              Теги:
            </a-col>
            <a-col :span="18" class="sm-mb">
              <vue-tags-input
                v-model="tag"
                :add-only-from-autocomplete="true"
                :autocomplete-items="
                  filteredItems.length ? filteredItems : ['Не найдено']
                "
                :tags="form.tags"
                class="post-chips__input"
                placeholder="Введите теги, можно указать несколько"
                @tags-changed="update"
              />
            </a-col>
          </a-row>

          <!-- news types list -->
          <a-row style="margin-bottom: 15px">
            <a-col
              :span="4"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Тип новости:
            </a-col>
            <a-col :span="18">
              <a-select
                v-model="newsType"
                :filter-option="filterOption"
                option-filter-prop="children"
                placeholder="Выберите тип новости"
                style="width: 100%"
              >
                <a-select-option
                  v-for="item in newsTypes"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name[$i18n.locale] }}
                </a-select-option>
              </a-select>
              <div v-if="!form.category_id" class="error-text">
                Выберите тип новости.
              </div>
            </a-col>
          </a-row>

          <!-- category list -->
          <a-row style="margin-bottom: 15px">
            <a-col
              :span="4"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Категория:
            </a-col>
            <a-col :span="18">
              <a-select
                v-model="form.category_id"
                :filter-option="filterOption"
                option-filter-prop="children"
                placeholder="Выберите категорию"
                show-search
                style="width: 100%"
              >
                <a-select-option
                  v-for="category in $store.getters['category/list']"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ JSON.parse(category.title)[langTab] }}
                </a-select-option>
              </a-select>
              <div v-if="!form.category_id" class="error-text">
                Выберите категорию.
              </div>
            </a-col>
          </a-row>

          <!-- published time -->
          <a-row>
            <a-col
              :span="4"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Дата публикации:
            </a-col>
            <a-col :span="18">
              <a-date-picker
                v-model="form.created"
                :allow-clear="false"
                :format="'DD-MMM YYYY HH:mm'"
                :show-time="{ format: 'HH:mm' }"
              />
            </a-col>
          </a-row>

          <!-- store image modal -->
          <a-modal
            :visible="modalVisible"
            title="Хранилище изображений"
            :closable="false"
            style="max-height: 500px; max-width: 900px"
            width="900px"
          >
            <imageStore
              @pasteHandler="editorInstance.insertContent(arguments[0])"
            />
            <template slot="footer">
              <a-button key="back" @click="modalVisible = false">
                Закрыть
              </a-button>
            </template>
          </a-modal>

          <!-- editor -->
          <a-row
            :class="{ 'form-group--error': emptyContent }"
            align="middle"
            style="margin-top: 25px"
          >
            <editor
              :key="'tinymce_' + tabPane"
              v-model="form.content[langTab]"
              style="
                padding-top: 4px;
                text-align: right;
                padding-right: 8px;
                overflow: hidden;
              "
              :init="{
                height: 450,
                plugins: [
                  'advlist autolink lists link image imagetools charmap print preview',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code wordcount'
                ],
                fontsize_formats:
                  '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                toolbar:
                  'undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                    storage-btn image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | basicDateButton selectiveDateButton toggleDateButton splitDateButton menuDateButton',
                language: 'ru',
                language_url: c_APP_PREFIX + '/js/tinymce/langs/ru.js',
                menubar: false,
                images_upload_url: false,
                automatic_uploads: false,
                relative_urls: false,
                images_reuse_filename: true,
                images_dataimg_filter: function (img) {
                  return img.hasAttribute('internal-blob')
                },
                external_plugins: {
                  myplugin:
                    c_APP_PREFIX +
                    '/js/tinymce/plugins/image-align/editor_plugin_img.js'
                },

                setup: (editor) => {
                  editor.ui.registry.addButton('storage-btn', {
                    icon: 'non-breaking',
                    tooltip: 'Хранилище изображений',
                    onAction: () => {
                      openStoreModal()
                      editorInstance = editor
                    }
                  })
                },

                image_advtab: true,
                importcss_append: true,
                image_caption: true
                // file_picker_callback: function(callback, value, meta) {
                //   console.log(callback, value, meta)
                //   // if (meta.filetype == 'image') {
                //   //   callback('img.jpg', {alt: 'My alt text'});
                //   // }
                // }
              }"
              api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
            />
            <div v-if="isContentNull" class="error-text">
              Введите контент на одном из языков.
            </div>
          </a-row>
        </a-tab-pane>

        <!-- photo tab -->
        <a-tab-pane key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="4"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения
            </a-col>
            <a-col :span="18">
              <image-upload
                :list="newsPhotos"
                :selected-image="main_image"
                accept="image/jpeg, image/png"
                method-name="news"
                multiple
                @change="handleImages"
                @drag-update="updateFilesPosition"
                @set-main-image="main_image = arguments[0]"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- video tab  -->
        <!-- <a-tab-pane key="video">
          <span slot="tab">
            <a-icon type="video-camera" />Видео для слайдера
          </span>

          <a-col>
            <a-row style="margin-bottom: 15px;">
              <a-col
                :span="4"
                style="text-align: right; padding-right: 8px; padding-top: 6px;"
              >
                Тип загрузки:
              </a-col>
              <a-col :span="18">
                <a-select
                  v-model="video_input.file_type"
                  placeholder="Выберите тип загрузки видео"
                  show-search
                  style="width: 100%;"
                >
                  <a-select-option
                    v-for="item in videoUploadTypes"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title[$i18n.locale] }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row
              v-if="video_input.file_type != 1"
              style="margin-bottom: 15px;"
            >
              <a-col
                :span="4"
                style="text-align: right; padding-right: 8px; padding-top: 6px;"
              >
                Ссылка на видео:
              </a-col>
              <a-col :span="18">
                  <a-col class="mb-2" v-for="(item, index) in videoUrl">
                    <a-input :placeholder="placeholders.video_url[$i18n.locale]" v-model="item.file"/>
                  </a-col>

                <a-col class="mb-2">
                  <a-input
                    v-model="video_input.file"
                    :placeholder="placeholders.video_url[$i18n.locale]"
                  />
                </a-col>
              </a-col>
            </a-row>

            <a-row
              v-else
              style="margin-bottom: 15px;"
            >
              <a-col
                :span="4"
                style="text-align: right; padding-right: 8px; padding-top: 6px;"
              >
                Файл с компьютера:
              </a-col>
              <a-col :span="18">
                <a-button @click="$refs.videoRef.click()">
                  <input
                    ref="videoRef"
                    accept="video/*"
                    hidden
                    type="file"
                    @change="handleVideoInput"
                  >
                  <a-icon type="upload" />Выберите файл
                </a-button>

                <InputFileItem
                  :file="video_file"
                  class="mt-2"
                  @delete="video_file = null"
                />
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>-->

        <!-- document tab  -->
        <!-- <a-tab-pane key="document">
          <span slot="tab">
            <a-icon type="file" />Документы
          </span>

          <a-col>
            <a-row style="margin-bottom: 15px;">
              <a-col
                :span="4"
                style="text-align: right; padding-right: 8px; padding-top: 6px;"
              >
                Файл документа:
              </a-col>
              <a-col :span="18">
                <a-button @click="$refs.documentRef.click()">
                  <input
                    ref="documentRef"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf"
                    hidden
                    type="file"
                    @change="handeDocumentInput"
                  >
                  <a-icon type="upload" />Выберите файл
                </a-button>

                <InputFileItem
                  :file="document_file"
                  class="mt-2"
                  @delete="$refs.documentRef.value = document_file = null"
                />
                <InputFileItem
                  v-for="(doc, index) in newsDocs"
                  :key="index"
                  :file="{ name: doc.file.split('/').pop() }"
                  class="mt-2"
                  link
                  @delete="deleteInputFile(doc)"
                />
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>-->
        <template slot="tabBarExtraContent">
          <span
            v-if="form.id && profile.access_level === 1"
            slot="tabBarExtraContent"
          >
            <a-popconfirm
              placement="topRight"
              title="Вы действительно хотите удалить данный новость?"
              @confirm="removeItem"
            >
              <a-button :disabled="pending" style="margin-right: 10px">
                <a-icon type="delete" />Удалить
              </a-button>
            </a-popconfirm>
          </span>
          <!-- v-show="!form.state" -->
          <!-- :disabled="!isUserHavePermissionsToSave" -->
          <a-button
            v-if="
              (!form.state || form.state == 1) && profile.access_level === 1
            "
            :loading="pending"
            type="primary"
            @click="submitNews"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>

          <template
            v-if="form.id && form.state == 1 && profile.access_level === 1"
          >
            <a-popconfirm
              placement="topRight"
              title="Одобрить новость?"
              @confirm="initNewsAccept"
            >
              <a-button class="ml-1" :loading="pending">
                <a-icon type="check" />Одобрить
              </a-button>
            </a-popconfirm>

            <a-popconfirm
              placement="topRight"
              title="Отклонить новость?"
              @confirm="initNewsReject"
            >
              <a-button class="ml-1" :loading="pending">
                <a-icon type="close" />Отклонить
              </a-button>
            </a-popconfirm>
          </template>
        </template>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="4" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <!-- :disabled="!isUserHavePermissionsToSave" -->
          <a-button
            v-if="(!form.state || form.state == 1) && isUserCanSave"
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submitNews"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>

          <template v-if="form.state && form.state == 1 && isUserCanSave">
            <a-popconfirm
              placement="topRight"
              title="Одобрить новость?"
              @confirm="initNewsAccept"
            >
              <a-button class="ml-1" :loading="pending">
                <a-icon type="check" />Одобрить
              </a-button>
            </a-popconfirm>
            <a-popconfirm
              placement="topRight"
              title="Отклонить новость?"
              @confirm="initNewsReject"
            >
              <a-button class="ml-1" :loading="pending">
                <a-icon type="close" />Отклонить
              </a-button>
            </a-popconfirm>
          </template>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
// import InputFileItem from "@/components/utils/input-file-item";
import cloneDeep from "lodash/cloneDeep"

import VueTagsInput from "@johmun/vue-tags-input"
import { mapState, mapActions } from "vuex"

const newsDefaultFields = () => ({
  title: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  content: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  excerp: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  category_id: null,
  slug: "",
  tags: [],
  position: 1,
  status: true,
  recommended: false,
  language_support: {
    uz: false,
    oz: false,
    ru: false,
    en: false,
    tj: false,
    kz: false
  },
  is_main: false,
  created: null
})

export default {
  name: "News",
  slugPrefix: "news",

  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    editor: Editor,
    // InputFileItem,
    VueTagsInput,
    imageStore: () => import("@/components/imageStore/imageStore")
  },
  data: () => ({
    editorInstance: null,
    // eslint-disable-next-line no-undef
    langTab: $langPrefix,
    form: {},
    created: null,
    groupCategoryList: [],
    fileList: [],
    pending: false,
    loading: false,

    previewVisible: false,
    previewImage: "",

    tabPane: null,
    main_image: null,
    video_input: {
      file_type: 3,
      file: ""
    },

    video_file: null,

    newsFiles: [],
    document_file: null,
    errors: {
      slug: ""
    },
    tag: "",
    autocompleteItems: [],
    tagTimer: null,
    emptyTitle: false,
    emptyContent: false,
    emptyExcerp: false,

    current_slug: "",

    newsTypes: [
      {
        value: "",
        name: {
          oz: "Номаълум",
          uz: "Noma'lum",
          ru: "Не определено",
          en: "Not selected",
          kz: "Белгісіз",
          tj: "Номуайян"
        }
      },
      {
        value: "actual",
        name: {
          oz: "Долзарб янгиликлар",
          uz: "Dolzarb yangiliklar",
          ru: "Актуальные новости",
          en: "Actuacl news",
          kz: "Өзекті жаңалықтар",
          tj: "Хабарҳои воқеӣ"
        }
      },
      {
        value: "is_main",
        name: {
          oz: "Избранные новости",
          uz: "Избранные новости",
          ru: "Избранные новости",
          en: "Favorite news",
          kz: "Таңдалған жаңалықтар",
          tj: "Хабарҳои интихобшуда"
        }
      },
      {
        value: "recommended",
        name: {
          oz: "Тавсия қилинадиган янгиликлар",
          uz: "Tavsiya qilinadigan yangiliklar",
          ru: "Рекомендованные новости",
          en: "Recommended news",
          kz: "Таңдаулы жаңалықтар",
          tj: "Хабарҳои интихобшуда"
        }
      }
    ],
    newsType: "",
    checkValue: [],
    modalVisible: false
  }),

  computed: {
    ...mapState({
      profile: (state) => state.user.profile || {},
      imagesCount: (state) => state.imageStore.items_count,
      list: (state) => state.imageStore.results
    }),
    isTitleNull() {
      return !!(
        !this.form.title.uz &&
        !this.form.title.oz &&
        !this.form.title.ru &&
        !this.form.title.en &&
        !this.form.title.tj &&
        !this.form.title.kz
      )
    },
    isContentNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en &&
        !this.form.content.tj &&
        !this.form.content.kz
      )
    },
    // isExcerpNull() {
    //   return !!(
    //     !this.form.excerp.uz &&
    //     !this.form.excerp.oz &&
    //     !this.form.excerp.ru &&
    //     !this.form.excerp.en
    //   );
    // },

    newsPhotos() {
      return (
        this.newsFiles && this.newsFiles.filter((item) => item.file_type === 0)
      )
    },

    newsVideos() {
      return (
        this.newsFiles &&
        this.newsFiles.filter(
          (item) =>
            item.file_type === 1 || item.file_type === 3 || item.file_type === 4
        )
      )
    },

    videoUrl() {
      return (
        this.newsFiles &&
        this.newsFiles
          .filter((item) => item.file_type === 3 || item.file_type === 4)
          .sort((a, b) => new Date(b.updated) - new Date(a.updated))
      )
    },

    newsDocs() {
      return (
        this.newsFiles && this.newsFiles.filter((item) => item.file_type === 2)
      )
    },

    filteredItems() {
      return this.autocompleteItems.filter(
        (i) =>
          (i.text || "")
            .toLowerCase()
            .indexOf((this.tag || "").toLowerCase()) !== -1
      )
    },

    isUserHavePermissionsToSave() {
      return (
        this.form &&
        this.profile &&
        this.form.author &&
        +this.profile.id == +this.form.author.id
      )
    },

    isUserCanSave() {
      if (!this.form.id) return true

      return this.form.id && this.profile.access_level == 1
    },

    c_APP_PREFIX() {
      return process.env.VUE_APP_PREFIX
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    tag: "initItems",
    "form.title": {
      handler(val) {
        try {
          // this.form.language_support[ ru or other lang prefix ] = true if form.title[ lang prefix ] exists or false
          this.$set(
            this.form.language_support,
            this.langTab,
            !!val[this.langTab]
          )
        } catch (error) {
          console.log(error)
        }
      },
      deep: true
    }
  },
  created() {
    this.form = {
      ...newsDefaultFields(),
      category_id: +this.$route.params.cat_id || null,
      created: this.moment(new Date(), "DD-MM-YYYY")
    }

    this.$store.dispatch("tags/fetch")
  },
  mounted() {
    this.$on("update:slug", this.onSlugChange)

    this.$on("slug-check-result", this.onSlugCheckResult)
  },
  // beforeDestroy() {
  //   // fields empty fix
  //   this.$set(this, "form", { ...newsDefaultFields() });
  // },

  methods: {
    ...mapActions("news", ["newsAccept", "newsReject"]),
    ...mapActions("imageStore", ["fetchImages", "removeImage", "submitImage"]),

    onSlugCheckResult(arg) {
      // console.log("onSlugCheckResult", arg);
      this.setSlugRes(arg)
    },
    openStoreModal() {
      this.modalVisible = true
    },
    async removeItem() {
      try {
        const r = await this.$store.dispatch(
          "news/deleteItemAction",
          this.form.id
        )
        if (r) {
          this.$message.success("Новость успешно удалена")
          this.$router.go(-1)
        }
      } catch (err) {
        console.error(err)
      }
    },
    onSlugChange(e) {
      const text = (e.target.value || "")
        .replace(/( )/gi, "-")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\\-]/gi, "")

      this.slugCheck({
        payload: { table: "post", slug: text },
        postType: "news"
      })

      this.form.slug = text
    },
    setSlugRes(arg) {
      this.errors.slug = arg ? "" : "Данный ЧПУ недоступен"
    },
    copySlug() {
      this.copyStringToClipboard(
        `/${this.$options.slugPrefix}/${this.form.slug}`
      )
      // pages/slug-iz-formy
      this.$message.success("ЧПУ скопирован")
    },
    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }

        if (this.form.content[from]) {
          this.form.content[to] = this[methodName](this.form.content[from])
        }

        if (this.form.excerp[from]) {
          this.form.excerp[to] = this[methodName](this.form.excerp[from])
        }

        // turn on translit target language_support
        this.$set(this.form.language_support, to, true)
      } catch (error) {
        console.log("translitAction error", error)
      }
    },
    update(newTags) {
      this.autocompleteItems = []
      this.form.tags = this.getTagStyles(newTags)
    },
    getTagStyles(tags) {
      // console.log(typeof tags, tags)
      tags.forEach((tag, index) => {
        const color = this.stringToHex(tag.text) || "#fff"
        tags[index].style = `background-color:${color};`
      })
      return tags
    },
    stringToHex(str) {
      if (!str) return ""
      let hash = 0
      if (str.length === 0) return hash
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
        hash = hash & hash
      }
      let color = "#"
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 255
        color += ("00" + value.toString(16)).substr(-2)
      }
      return color
    },
    initItems() {
      // chips, tags fetcher function

      if (this.tag.length < 2) {
        return
      }

      clearTimeout(this.tagTimer)
      this.tagTimer = setTimeout(async () => {
        try {
          const data = await this.$store.dispatch("tags/fetch")

          this.autocompleteItems = (data || []).map((item) => ({
            ...item,
            text: (item.name || {})[this.$i18n.locale] || "-"
          }))
        } catch (e) {
          console.error("initItems", e)
        }
      }, 800)
    },
    handleVideoInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_file = e.target.files[0]
      }

      this.$refs.videoRef.value = null
    },
    handeDocumentInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.document_file = e.target.files[0]
      }
    },

    updateFilesPosition() {
      if (!this.form.id) {
        return false
      }
      let promises = []
      let otherImages = new FormData()
      const mainImage = this.fileList.find(
        (item) => item.id && item.uzid === this.main_image
      )

      if (mainImage) {
        otherImages.append("news_id", this.form.id)
        otherImages.append("is_main", true)
        otherImages.append("file_type", 0)
        otherImages.append("position", 1)
        otherImages.append("status", true)
        otherImages.append("file", mainImage.file || mainImage.fileTarget)
        promises.push(
          this.$api.put("/news/file/update/" + mainImage.id, otherImages)
        )
      }

      // console.log(+!!mainImage);

      // debugger;

      Array.from(this.fileList)
        .filter((item) => item.id && item.uzid !== this.main_image)
        .map((item, index) => {
          otherImages = new FormData()

          otherImages.append("news_id", this.form.id)
          otherImages.append("is_main", false)
          otherImages.append("position", index + 1 + ((mainImage && 1) || 0))
          otherImages.append("file", item.file)
          otherImages.append("status", true)
          otherImages.append("file_type", 0)

          promises.push(
            this.$api.put("/news/file/update/" + item.id, otherImages)
          )
        })

      Promise.all(promises)
        .then(
          (res) => {
            console.log(res)
          },
          (err) => {
            console.log(err)
          }
        )
        .then(() => {
          // console.log(res);
          this.$message.success("Позиции успешно сохранены")
        })
    },

    check2Null(arg) {
      return Object.values(arg).every((item) => !item)
    },
    submitNews() {
      if (
        this.form.id &&
        +this.profile.access_level != 1 &&
        !this.isUserHavePermissionsToSave
      ) {
        this.$message.error("Вы не можете сохранить новость других авторов")
        return
      }

      if (this.check2Null(this.form.title)) {
        this.emptyTitle = true
        this.$message.error("Введите заголовок на одном из языков")
        return
      }
      if (this.check2Null(this.form.content)) {
        this.emptyContent = true
        this.$message.error("Введите контент на одном из языков")
        return
      }
      // if (this.check2Null(this.form.excerp)) {
      //   this.emptyExcerp = true;
      //   this.$message.error("Введите подзаголовок на одном из языков");
      //   return;
      // }

      if (!this.form.slug) {
        this.$message.error("Введите или генерируйте ЧПУ")
        return
      }

      if (this.errors.slug && this.current_slug != this.form.slug) {
        this.$message.error("ЧПУ занят, введите другое")
        return
      }

      if (this.form.slug && this.form.slug.length >= 200) {
        this.$message.error(
          "Количество символов в ЧПУ превышает предел 200 символов, укоротите ЧПУ"
        )
        return
      }

      if (!this.form.category_id) {
        this.$message.error("Выберите категорию")
        return
      }

      ;["actual", "is_main", "recommended"].map((item) => {
        this.form[item] = item == this.newsType
      })

      // do your submit logic here

      this.pending = true

      let newData = cloneDeep(this.form)

      newData = {
        ...newData,
        title: JSON.stringify(newData.title),
        content: JSON.stringify(newData.content),
        excerp: JSON.stringify(newData.excerp),
        created: this.moment(newData.created)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        tags: (newData.tags || []).map((item) => +item.id)
      }

      const createOrUpdate = {
        url:
          this.form && this.form.id
            ? "/news/post/update/" + this.form.id
            : "/news/post/create",
        method: this.form && this.form.id ? "put" : "post",
        data: newData
      }

      console.log("createOrUpdate", createOrUpdate)
      this.pending = false

      this.$api[createOrUpdate.method](
        createOrUpdate.url,
        createOrUpdate.data,
        { timeout: 0 }
      )
        .then((res) => {
          if (res && res.status >= 200 && res.data && res.data.id) {
            if (res.data.id) {
              const { id } = res.data

              this.form = { ...this.form, id }

              // upload after post done
              this.uploadPostFiles()
            }
          }
        })
        .catch((err) => {
          console.error(err)
          this.pending = false
        })
    },
    uploadPostFiles() {
      this.pending = true

      let promises = []

      // upload images
      Array.from(this.fileList).map((item, index) => {
        const img = new FormData()

        let filePositionNumber = index + 1 + ((this.main_image && 1) || 0)

        const req = {
          attr: "create",
          id: this.form.id,
          method: "post"
        }

        if (item.id) {
          req.attr = "update/" + item.id
          req.id = item.id
          req.method = "put"
          img.append("file", item.file)
        } else {
          img.append("file", item.fileTarget)
        }

        // console.log(index, req.attr, 'file', item.fileTarget || item.file);

        img.append("is_main", this.main_image == item.uzid)
        img.append("news_id", this.form.id)
        img.append("file_type", 0)
        img.append("status", true)

        // if (this.main_image == item.uzid) img.append("position", 1)
        // else {
        img.append("position", filePositionNumber)
        // }

        promises.push(this.$api[req.method](`/news/file/${req.attr}`, img))
      })

      // upload video
      if (this.video_input.file && this.form.id) {
        const videoInputForm = new FormData()
        let req = {
          url: "create",
          method: "post"
        }

        videoInputForm.append(
          "file",
          this.video_input.file_type == 1
            ? this.video_file
            : this.video_input.file
        )

        videoInputForm.append("file_type", this.video_input.file_type)
        videoInputForm.append("news_id", this.form.id)
        videoInputForm.append("status", true)
        videoInputForm.append("is_main", true)
        videoInputForm.append("position", 1)

        if (this.video_input.id) {
          req = {
            url: "update/" + this.video_input.id,
            method: "put"
          }
        }

        promises.push(
          this.$api[req.method]("/news/file/" + req.url, videoInputForm)
        )
      }

      // upload docs
      if (this.document_file) {
        const documentForm = new FormData()
        documentForm.append("file", this.document_file)
        documentForm.append("news_id", this.form.id)
        documentForm.append("file_type", 2)
        documentForm.append("status", true)
        documentForm.append("is_main", true)
        documentForm.append("position", 1)
        promises.push(this.$api.post("/news/file/create", documentForm))
      }

      Promise.all(promises)
        .then(
          (res) => {
            console.log(res)
          },
          (err) => {
            console.log(err)
          }
        )
        .then(() => {
          this.pending = false
          this.$message.success("Новость успешно сохранено")
          this.$router.go(-1)
        })
        .catch(() => (this.pending = false))
    },
    async fetchData() {
      this.loading = true
      this.$store.dispatch("category/fetch")
      if (isNaN(this.$route.params.id)) {
        this.loading = false
        return
      }

      this.$api
        .get("/news/post/detail/" + this.$route.params.id, {
          headers: {
            "Accept-Language": ""
          }
        })
        .then(async (res) => {
          if (res && res.data) {
            // skip non important keys
            // eslint-disable-next-line no-unused-vars
            const { category, created, updated, views, ...data } = res.data

            this.form = {
              ...this.form,
              ...data,
              title: JSON.parse(data.title),
              content: JSON.parse(data.content),
              excerp: JSON.parse(data.excerp),
              created: this.moment(created),
              updated: this.moment(created),
              views: views,
              tags: this.getTagStyles(
                (data.tag_list || []).map(({ id, name }) => ({
                  id,
                  text:
                    ((name && JSON.parse(name)) || {})[this.$i18n.locale] || "-"
                }))
              ),
              language_support: data.language_support
            }

            this.current_slug = this.form.slug

            const selectedNewsType = ["actual", "is_main", "recommended"].find(
              (item) => (!!data[item] && item) || ""
            )
            this.newsType = selectedNewsType || ""
          }

          await this.fetchNewsFiles()
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },

    async fetchNewsFiles() {
      if (!this.$route.params.id) {
        console.log("No params id")
        return
      }

      return this.$api
        .get("/news/file/list/" + this.$route.params.id)
        .then((res) => {
          // console.log("fetchNewsFiles", res);
          this.newsFiles = res.data

          // set first element of video files as video_url
          if (
            this.videoUrl &&
            this.videoUrl.length &&
            this.videoUrl[0] &&
            this.videoUrl[0].file
          ) {
            this.video_input = this.videoUrl[0]
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      console.log(fileList)
      this.fileList = fileList
    },
    handleImages(arg) {
      this.fileList = arg
    },
    tabPaneChangeHandler(arg) {
      // tinymce reload fix, !!! important
      this.tabPane = arg
    },

    async deleteInputFile(arg) {
      try {
        const res = await this.$store.dispatch("file/delete", arg.id)

        if (res) {
          const f = this.newsFiles.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.newsFiles.splice(f, 1)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },

    initNewsAccept() {
      this.runWithCallback([this.newsAccept(this.form.id)], () =>
        this.$router.go(-1)
      )
    },

    initNewsReject() {
      this.runWithCallback([this.newsReject(this.form.id)], () =>
        this.$router.go(-1)
      )
    }
  }
}
</script>
<style>
.ant-modal {
  max-height: 600px;
}
.scroll-container {
  padding: 20px 0px;
}
</style>
